import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from "react-i18next";
import styles from '../../../SearchWidget.module.scss';
import OutsideClickWatcher from "../../../../Common/OutsideClickWatcher";
import VisibilityWrapper from "../../../../Common/VisibilityWrapper";
import {Col, Row} from "react-bootstrap";
import NumberPicker from "../../../../Common/NumberPicker/NumberPicker";
import RadioBtn from "../../../../Common/RadioBtn/RadioBtn";
import {connect} from "react-redux";
import {setPassengers, setPassengerType, setPassengerTypeWasChanged} from '../../../../../services/flightCourse/actions';
import WindowEventWatcher from "../../../../Common/WindowEventWatcher";
import {refBlur, refFocus} from "../../../../../tools/tools";
import animations from '../../../../../assets/scss/animations/animate.module.scss';
import shiftAware from "../../../../../hoc/ShiftAware/ShiftAware";
import Tooltip from "../../../../Common/Tooltip/Tooltip";
import DoneBtn from "../../../../Common/DoneBtn/DoneBtn";

export const PAX_TYPES = {
    REGULAR: 'ADULT',
    RESIDENT: 'RESIDENT',
    STUDENT: 'STUDENT'
};

class PassengerOptions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            lastIsFocused: false,
            adultsClasses: '',
            childrenClasses: '',
            infantsClasses: '',
            animationClasses: '',
            somethingWasOutOfBounds: false
        };

        this.localContainerRef = React.createRef();

        this.adultsRef = React.createRef();
        this.childrenRef = React.createRef();
        this.infantsRef = React.createRef();

        this.regularRef = React.createRef();
        this.residentRef = React.createRef();
        this.studentRef = React.createRef();
    }

    optionsVisibilityHandler = (variant = null) => {
        if (typeof variant === 'boolean') {
            return this.setState({open: variant});
        }

        return this.setState(prevState => ({open: !prevState.open}));
    };

    isValidPaxType = paxType => Object.values(PAX_TYPES).includes(paxType);

    changePaxTypeHandler = option => {
        if (this.isValidPaxType(option)) {
            const {setPassengerType, setPassengerTypeWasChanged} = this.props;
            setPassengerType(option);
            if (option === PAX_TYPES.STUDENT) {
                const {flightCourseState} = this.props;
                const {childrenAmount, infantsAmount} = flightCourseState;
                if (childrenAmount || infantsAmount) {
                    setPassengerTypeWasChanged(true);
                    this.changePaxAmountHandler({children: 0, infants: 0});
                }
            }
        }
    };

    changePaxAmountHandler = ({adults, children, infants}) => {
        const {flightCourseState, setPassengers} = this.props;
        const {adultsAmount, childrenAmount, infantsAmount} = flightCourseState;
        adults = !isNaN(adults) ? adults : adultsAmount;
        children = !isNaN(children) ? children : childrenAmount;
        infants = !isNaN(infants) ? infants : infantsAmount;

        if (!isNaN(adults) && !isNaN(children) && !isNaN(infants)) {
            setPassengers(adults, children, infants);
        }
    };

    clickPaxTypeHandler = (e, v) => {
        if (v && v.hasOwnProperty('paxType') && v.paxType) {
            const {nextRef} = this.props;
            this.changePaxTypeHandler(v.paxType);
            this.blurHandler();
            refFocus(nextRef);
        }
    };

    keyDownPaxTypeHandler = (e, v) => {
        const code = e.code ? e.code : e.key;

        const {nextRef} = this.props;
        switch (code) {
            case ' ':
            case 'Space':
            case 'NumpadEnter':
            case 'Enter':
                if (v && v.hasOwnProperty('paxType') && v.paxType) {
                    this.changePaxTypeHandler(v.paxType);
                    this.blurHandler();
                    refFocus(nextRef);
                    break;
                }
                return;
            default:
                return;
        }

        e.preventDefault();
        e.stopPropagation();
    };

    keyDownHandler = e => {
        const code = e.code ? e.code : e.key;

        const {prevRef, nextRef, shiftPressed} = this.props;
        if (code === 'Tab' && shiftPressed) {
            this.blurHandler();
            refFocus(prevRef);
            e.stopPropagation();
            e.preventDefault();
            return;
        }

        switch (code) {
            case 'Left':
            case 'ArrowLeft':
                this.blurHandler();
                refFocus(prevRef);
                break;
            case ' ':
            case 'Space':
            case 'NumpadEnter':
            case 'Enter':
            case 'Right':
            case 'ArrowRight':
                this.blurHandler();
                refFocus(nextRef);
                break;
            case 'Escape':
                this.blurHandler();
                break;
            case 'Tab':
                const {lastIsFocused} = this.state;
                if (lastIsFocused) {
                    this.blurHandler();
                    refFocus(nextRef);
                    break;
                }
                return;
            default:
                return;
        }

        e.preventDefault();
        e.stopPropagation();
    };

    focusHandler = () => {
        const {wasClosedJustNow} = this.state;
        if (wasClosedJustNow) return;
        this.setState({open: true, animationClasses: `${animations.animated} ${animations.touchEffect}`});
        setTimeout(() => this.setState({animationClasses: ''}), 500);
    };

    blurHandler = () => {
        const {contRef} = this.props;
        this.setState({open: false, lastIsFocused: false});
        refBlur(contRef, this.localContainerRef);
    };

    changeClasses = (variant, classes = [animations.animated, animations.shake].join(' ')) => {
        this.setState(
            {[variant]: classes, somethingWasOutOfBounds: true},
            () => setTimeout(() => this.clearClasses(variant), 500)
        );
    };

    clearClasses = variant => {
        this.setState({[variant]: ''});
    };

    render() {
        const {setPassengerTypeWasChanged, flightCourseState, contRef, multiCityMode, animated, t} = this.props;
        const {open, adultsClasses, childrenClasses, infantsClasses, animationClasses, somethingWasOutOfBounds} = this.state;
        const {legs, adultsAmount, childrenAmount, infantsAmount, passengerType, passengerTypeWasChanged, imagineMode} = flightCourseState;
        const [firstLeg] = legs;
        const {origin, destination} = firstLeg;
        const containerRef = contRef ? contRef : this.localContainerRef;
        const isOSP = origin && destination && origin.hasOwnProperty('destinationsOSP')
            && destination.hasOwnProperty('code') && origin.destinationsOSP.includes(destination.code);
        const headerLabelClasses = [styles.POLabel];
        const containerClasses = ['sw-hidden-on-shrink', styles.passengerOptionsContainer];
        if (open) containerClasses.push(styles.focused);
        if (animated) containerClasses.push(animationClasses);

        const onlyRegular = !isOSP || multiCityMode || imagineMode;

        return (
            <div className={containerClasses.join(' ')}>
                <div className={headerLabelClasses.join(' ')}
                     ref={containerRef}
                     role={'form'}
                     tabIndex={0}
                     onClick={this.focusHandler}
                     onFocus={this.focusHandler}>
                    <Tooltip show={passengerTypeWasChanged}>
                        <WindowEventWatcher
                            listening={passengerTypeWasChanged}
                            eventName={'mousedown'} handlerFn={() => setPassengerTypeWasChanged(false)}/>
                        <i className="fa fa-exclamation-triangle"
                           aria-hidden="true"/>&nbsp;{t('Passenger type was changed.')}
                    </Tooltip>
                    {adultsAmount} <i className={[styles.POLabelAdultIcon, 'icon-sata-adult'].join(' ')} aria-hidden={true}/>&nbsp;
                    {childrenAmount} <i className={[styles.POLabelChildrenIcon, 'icon-sata-adult'].join(' ')} aria-hidden={true}/>&nbsp;
                    {infantsAmount} <i className={[styles.POLabelInfantsIcon, 'icon-sata-infant'].join(' ')} aria-hidden={true}/>
                </div>
                <VisibilityWrapper visible={open}>
                    <OutsideClickWatcher handleClickOutside={(e) => {
                        this.setState({open: false, wasClosedJustNow: true}, () => {
                            setTimeout(() => this.setState({wasClosedJustNow: false}), 250);
                        });
                    }}>
                        <WindowEventWatcher
                            listening={open}
                            eventName={'keydown'}
                            handlerFn={this.keyDownHandler}/>
                        <div className={styles.POFloatContainer}>
                            <Row>
                                <Col className='col-xs-8' sm={8}>{t('Adults')}&nbsp;
                                    <small>{t('(+12 years old)')}</small>
                                </Col>
                                <Col className='col-xs-4' sm={4}>
                                    <NumberPicker
                                        inputRef={this.adultsRef}
                                        editable
                                        changeHandler={n => this.changePaxAmountHandler({adults: n})}
                                        containerClasses={adultsClasses}
                                        outOfBoundsHandler={() => this.changeClasses('adultsClasses')}
                                        value={adultsAmount}
                                        min={infantsAmount || 1}
                                        max={8 - childrenAmount}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col className='col-xs-8' sm={8}>{t('Children')}&nbsp;
                                    <small>{t('(2-11 years old)')}</small>
                                </Col>
                                <Col className='col-xs-4' sm={4}>
                                    <NumberPicker
                                        inputRef={this.childrenRef}
                                        editable
                                        changeHandler={n => this.changePaxAmountHandler({children: n})}
                                        containerClasses={childrenClasses}
                                        outOfBoundsHandler={() => this.changeClasses('childrenClasses')}
                                        value={childrenAmount}
                                        disabled={PAX_TYPES.STUDENT === passengerType}
                                        min={0}
                                        max={8 - adultsAmount}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col className='col-xs-8' sm={8}>{t('Infants')}&nbsp;
                                    <small>{t('(0-23 months old)')}</small>
                                </Col>
                                <Col className='col-xs-4' sm={4}>
                                    <NumberPicker
                                        inputRef={this.infantsRef}
                                        editable
                                        changeHandler={n => this.changePaxAmountHandler({infants: n})}
                                        containerClasses={infantsClasses}
                                        outOfBoundsHandler={() => this.changeClasses('infantsClasses')}
                                        disabled={PAX_TYPES.STUDENT === passengerType}
                                        value={infantsAmount}
                                        min={0}
                                        max={adultsAmount}/>
                                </Col>
                            </Row>
                            {somethingWasOutOfBounds &&
                            <Row>
                                <Col
                                    className={['col-xs-12', styles.POPaxInfoContainer, animations.animated, animations.fadeIn].join(' ')}>
                                    <p><i className='fa fa-info-circle'
                                          style={{color: '#52C6E2'}}/> {t("Maximum number of passengers")}: 8</p>
                                    <p>{t('The number of infants cannot exceed the number of adults.')}</p>
                                </Col>
                            </Row>
                            }
                            <Row>
                                <Col className='col-xs-12'>
                                    <div className={styles.POPaxTypesContainer}>
                                        <span className={styles.POPaxTypesTitle}>{t('Type of passenger')}</span>
                                        <div className={styles.PORadioContainer}
                                             ref={this.regularRef}
                                             tabIndex={0}
                                             onFocus={onlyRegular ? () => this.setState({lastIsFocused: true}) : () => null}
                                             onKeyDown={e => this.keyDownPaxTypeHandler(e, {paxType: PAX_TYPES.REGULAR})}
                                             onClick={e => this.clickPaxTypeHandler(e, {paxType: PAX_TYPES.REGULAR})}>
                                            <RadioBtn
                                                checked={PAX_TYPES.REGULAR === passengerType}/>&nbsp;{t('Regular')}
                                        </div>
                                        <div
                                            className={[styles.PORadioContainer, onlyRegular && styles.PORadioContainerDisabled].join(' ')}
                                            ref={this.residentRef}
                                            tabIndex={!onlyRegular ? 0 : -1}
                                            onKeyDown={onlyRegular ? () => null : e => this.keyDownPaxTypeHandler(e, {paxType: PAX_TYPES.RESIDENT})}
                                            onClick={onlyRegular ? () => null : e => this.clickPaxTypeHandler(e, {paxType: PAX_TYPES.RESIDENT})}>
                                            <RadioBtn
                                                disabled={onlyRegular}
                                                checked={PAX_TYPES.RESIDENT === passengerType}/>&nbsp;{t('Resident in the Azores')}
                                        </div>
                                        <div
                                            className={[styles.PORadioContainer, onlyRegular && styles.PORadioContainerDisabled].join(' ')}
                                            ref={this.studentRef}
                                            tabIndex={!onlyRegular ? 0 : -1}
                                            onFocus={!onlyRegular ? () => this.setState({lastIsFocused: true}) : () => null}
                                            onKeyDown={onlyRegular ? () => null : e => this.keyDownPaxTypeHandler(e, {paxType: PAX_TYPES.STUDENT})}
                                            onClick={onlyRegular ? () => null : e => this.clickPaxTypeHandler(e, {paxType: PAX_TYPES.STUDENT})}>
                                            <RadioBtn
                                                disabled={onlyRegular}
                                                checked={PAX_TYPES.STUDENT === passengerType}/>&nbsp;{t('Student')} {t('(12-26 years old)')}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <DoneBtn clickHandler={this.blurHandler} inlineStyles={{padding: '0 5px 5px 0'}} withIcon/>
                        </div>
                    </OutsideClickWatcher>
                </VisibilityWrapper>
            </div>
        );
    }
}

PassengerOptions.propTypes = {
    flightCourseState: PropTypes.object,
    setPassengers: PropTypes.func,
    setPassengerType: PropTypes.func,
    setPassengerTypeWasChanged: PropTypes.func,
    multiCityMode: PropTypes.bool,
    shiftPressed: PropTypes.bool,
    contRef: PropTypes.any,
    prevRef: PropTypes.any,
    nextRef: PropTypes.any,
    animated: PropTypes.bool,
    t: PropTypes.func,
};

PassengerOptions.defaultProps = {
    flightCourseState: null,
    setPassengers: () => null,
    setPassengerType: () => null,
    setPassengerTypeWasChanged: () => null,
    multiCityMode: false,
    shiftPressed: false,
    contRef: null,
    prevRef: null,
    nextRef: null,
    animated: false,
    t: str => str,
};

export default withTranslation()(connect(state => ({flightCourseState: state.flightCourse}), {
    setPassengers, setPassengerType, setPassengerTypeWasChanged
})(shiftAware(PassengerOptions)));
